








































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateSkillRequest from '@/models/Skills/CreateSkillRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'SkillCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new CreateSkillRequest();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateSkillRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }
       
    await AgencySettingsModule.createSkill(this.entity)
    this.dialog = false;
  }
}
